import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Grid,
    Header,
    Icon,
    Input,
    Loader,
    Popup,
    Responsive,
    Segment,
    Select,
    Tab,
    Table
} from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';
import { ExportReactCSV } from '../../util/ExportCSV';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import ReactExport from 'react-data-export';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class Exams extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            id: null,
            name: '',
            loading: true,

            filterData: [],

            documentNumber: null,
            inputDocNum: false,
            docNumErr: false,
            activeIndex: 0,
            load: true,
            filterMode: false,

            SPBasics: [],
            SPBasic: '',

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],
            excelData: [],
            excelDataFinalized: []
        };

        this.getExams = this.getExams.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.unfinalizedExam = this.unfinalizedExam.bind(this);
        this.archive = this.archive.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getFilteredExams = this.getFilteredExams.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {

        axios.post(localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja' ? `study-programs/basic/${localStorage.getItem('orgUnit')}`
            : 'study-programs/basic', {})
            .then(res => {
                this.setState({
                    SPBasics: res.data.filter(el => !el.studyProgramBasic.archived).map(el => ({
                        key: el.studyProgramBasic.id,
                        value: el.studyProgramBasic.id,
                        text: el.studyProgramBasic.name,
                        description: el.studyProgramBasic.studyCycles[0].name + (el.studyProgramBasic.comment ? ' | ' + el.studyProgramBasic.comment : '')
                    }))
                });
            })
            .catch(err => {
                console.log('Failed to fetch study programs');
            });



        window.localStorage.removeItem('gradedActivityId');
        window.localStorage.removeItem('courseImplementationName');
        window.localStorage.removeItem('gradedActivityName');
        window.localStorage.removeItem('date');

        if (localStorage.getItem('tab')) {
            this.setState({ activeIndex: parseInt(localStorage.getItem('tab'), 10) });
        }


            this.getExams(this.props.location.state && this.props.location.state .id ? this.props.location.state.id: localStorage.getItem('id'));
            if(this.props.location.state && this.props.location.state.id && this.props.location.state.name ){
                localStorage.setItem('id', this.props.location.state.id);
                localStorage.setItem('name', this.props.location.state.name);
            }


    }

    getFilteredExams(SPBasic) {
        this.setState({ loading: true });
        axios.get(`/exams/by-term-and-sp/${parseInt(localStorage.getItem('id'), 10)}/${SPBasic}`, )
            .then(res => {
                this.setState({
                    filterData: res.data.map(el => ({
                        ...el, gradedActivityDateFormated: moment(el.gradedActivityDate).format('D. M. YYYY.')
                    })),
                    loading: false
                });
                const excelData = res.data.filter(e => !e.finalized).map(el => ([
                    { value: el.courseImplementationName},
                    { value: el.courseComment ? el.courseComment : '' },
                    { value: el.gradedActivityName},
                    { value: moment(el.gradedActivityDate).format('D. M. YYYY.') },
                    { value: el.comment ? el.comment : ''}
                ]));
                this.setState({excelData: excelData});

                const excelDataFinalized = res.data.filter(e => e.finalized).map(el => ([
                    { value: el.courseImplementationName},
                    { value: el.courseComment ? el.courseComment : '' },
                    { value: el.gradedActivityName},
                    { value: moment(el.gradedActivityDate).format('D. M. YYYY.') },
                    { value: el.comment ? el.comment : ''}
                ]));
                this.setState({excelDataFinalized: excelDataFinalized});
            })
            .catch(err => {
                console.log('Failed to fetch exams');
            });
    }

    getExams(id) {
        let obj = {};
        axios.post(`/exams/by-term/${id}`, { ...obj })
            .then(res => {
                this.setState({
                    data: res.data.map(el => ({
                        ...el, gradedActivityDateFormated: moment(el.gradedActivityDate).format('D. M. YYYY.')
                    })),
                    loading: false,
                    id
                });
                const excelData = res.data.filter(e => !e.finalized).map(el => ([
                    { value: el.courseImplementationName},
                    { value: el.courseComment ? el.courseComment : '' },
                    { value: el.gradedActivityName},
                    { value: moment(el.gradedActivityDate).format('D. M. YYYY.') },
                    { value: el.comment ? el.comment : ''}
                ]));
                this.setState({excelData: excelData});

                const excelDataFinalized = res.data.filter(e => e.finalized).map(el => ([
                    { value: el.courseImplementationName},
                    { value: el.courseComment ? el.courseComment : '' },
                    { value: el.gradedActivityName},
                    { value: moment(el.gradedActivityDate).format('D. M. YYYY.') },
                    { value: el.comment ? el.comment : ''}
                ]));
                this.setState({excelDataFinalized: excelDataFinalized});
            })
            .catch(err => {
                console.log('Failed to fetch exams');
            });
    }

    archive(id, optLock) {
        let obj = { id, optLock };
        axios.put('/exams/archive', { ...obj })
            .then(res => {
                toast('Uspješno ste arhivirali ispit.');
                this.getExams(parseInt(localStorage.getItem('id'), 10));
                this.setState({ activeIndex: 1 });
            })
            .catch(err => {
                toast('Došlo je do greške! Arhiviranje ispita nije uspjelo.');
            });
    }

    unfinalizedExam(id, optLock) {
        this.setState({ load: false });
        if (!this.state.documentNumber) {
            toast('Morate unijeti broj odluke!');
            this.setState({ docNumErr: true });
            return;
        }

        let obj = {
            optLock,
            id,
            documentNumber: this.state.documentNumber
        };
        axios.put('/exams/cancel-finalization', { ...obj })
            .then(res => {
                toast('Uspješno ste otvorili ispit.');
                this.setState({ inputDocNum: false, load: true, documentNumber: null });
                this.getExams(parseInt(localStorage.getItem('id'), 10));
            })
            .catch(err => {
                toast('Došlo je do greške!');
            });
    }


    getDataToRender() {
        if (this.state.filterMode) {
            return this.state.filterData;
        }
        return this.state.data;
    }


    removeExam(id) {
        this.setState({loader: true})
        let obj = {
            gradedActivity: { id },
            gradedActivityRegistrationDate: { id: localStorage.getItem('id') }
        };
        axios.get(`exams/staff/${id}`)
            .then(res => {
                    axios.delete('/exams/delete', { data: obj })
                        .then(res => {
                            toast('Uspješno ste obrisali ispit.');
                            this.getExams(parseInt(localStorage.getItem('id'), 10));
                            this.setState({loader: false})

                        })
                        .catch(err => {
                            this.setState({ loader: false })
                            if (err.response.data === 'Could not delete exam. Students were registered exam.') {
                                toast('Ispit nije obrisan jer ima prijavljenih studenata.');
                            } else if (err.response.data === 'Could not delete GradedActivityGradedActivityRegistrationDate.') {
                                toast('Došlo je do greške! Ispit nije izbrisan.');
                            } else if (err.response.data === 'Could not delete StaffGradedActivity.') {
                                toast('Došlo je do greške! Ispit nije izbrisan.');
                            } else toast('Došlo je do greške! Ispit nije izbrisan.');
                        });

            });
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({
            activeIndex, filterMode: false, name: '', date: null, SPBasic: ''
        });
        localStorage.setItem('tab', activeIndex);
    }

    handleInputChange(event, { name, value }) {
        let filterData = [];
        if (name === 'name') {
            this.setState({ date: null });
            filterData = this.state.SPBasic !== '' ? this.state.filterData.filter((e) => e.courseImplementationName.toLowerCase().match(value.toLowerCase())) : this.state.data.filter((e) => e.courseImplementationName.toLowerCase().match(value.toLowerCase()));
            this.setState({ filterMode: true });
        }
        if (name === 'SPBasic') {
            if (!value) {
                this.setState({ filterMode: false });
                const excelData = this.state.data.filter(e => !e.finalized).map(el => ([
                    { value: el.courseImplementationName},
                    { value: el.courseComment ? el.courseComment : '' },
                    { value: el.gradedActivityName},
                    { value: moment(el.gradedActivityDate).format('D. M. YYYY.') },
                    { value: el.comment ? el.comment : ''}
                ]));
                this.setState({excelData: excelData});

                const excelDataFinalized = this.state.data.filter(e => e.finalized).map(el => ([
                    { value: el.courseImplementationName},
                    { value: el.courseComment ? el.courseComment : '' },
                    { value: el.gradedActivityName},
                    { value: moment(el.gradedActivityDate).format('D. M. YYYY.') },
                    { value: el.comment ? el.comment : ''}
                ]));
                this.setState({excelDataFinalized: excelDataFinalized});
            } else {
                this.setState({ filterMode: true });
                this.getFilteredExams(value);
            }
            this.setState({ name: '', date: null });
        }
        this.setState({
            [name]: value,
            filterData
        });
    }

    handleDateChange(name, date) {
        this.setState({ name: '' });
        console.log(moment(date), 'Date', date);
        let filterData = [];
        filterData = this.state.SPBasic ? this.state.filterData.filter((e) => moment(e.gradedActivityDate).format('D. M. YYYY.') === moment(date).format('D. M. YYYY.')) : this.state.data.filter((e) => {
            console.log(moment(e.gradedActivityDate).format('D. M. YYYY.'));
            console.log(moment(date).format('D. M. YYYY.'));
            if (moment(e.gradedActivityDate).format('D. M. YYYY.') === moment(date).format('D. M. YYYY.')) { return e; }
        });
        this.setState({
            [name]: date, filterMode: true, filterData
        }, () => this.state.date === null ? this.setState({ filterMode: false }) : '');
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {

        const headersForExport = [
            { label: 'Predmet', key: 'courseImplementationName' },
            { label: 'Napomena (predmet)', key: 'courseComment' },
            { label: 'Tip ispita', key: 'gradedActivityName' },
            { label: 'Datum i vrijeme ispita', key: 'gradedActivityDateFormated' },
            { label: 'Napomena (ispit)', key: 'comment' }
        ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Predmet', width: { wpx: 500 } },
                    { title: 'Napomena (predmet)', width: { wpx: 150 } },
                    { title: 'Tip ispita', width: { wpx: 150 } },
                    { title: 'Datum i vrijeme ispita', width: { wpx: 150 } },
                    { title: 'Napomena (ispit)', width: { wpx: 500 } },
                ],
                data: this.state.excelData,
            }
        ];

        const multiDataSetFinalized = [
            {
                columns: [
                    { title: 'Predmet', width: { wpx: 500 } },
                    { title: 'Napomena (predmet)', width: { wpx: 150 } },
                    { title: 'Tip ispita', width: { wpx: 150 } },
                    { title: 'Datum i vrijeme ispita', width: { wpx: 150 } },
                    { title: 'Napomena (ispit)', width: { wpx: 500 } },
                ],
                data: this.state.excelDataFinalized,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);


        const panes = [
            {
                menuItem: 'Nefinalizirani ispiti',
                render: () => (<Tab.Pane as={Responsive}>

                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field
                                clearable
                                control={Select}
                                label="Odsjek / smjer"
                                placeholder="Odaberite odsjek / smjer"
                                name="SPBasic"
                                search
                                options={this.state.SPBasics}
                                value={this.state.SPBasic}
                                onChange={this.handleInputChange}

                            />
                            <Form.Field
                                control={Input}
                                label="Predmet"
                                placeholder="Unesite predmet"
                                name="name"
                                value={this.state.name}
                                onChange={this.handleInputChange}

                            />
                            <Form.Field>
                                <label>Datum ispita</label>
                                <DateTimePicker
                                    time={false}
                                    format="D. M. YYYY."
                                    onChange={this.handleDateChange.bind(null, 'date')}
                                    value={this.state.date}
                                    placeholder="Unesite datum"
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                    {this.getDataToRender().filter(e => !e.finalized).length ?


                        <Table celled selectable compact >
                           <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width="1">R.br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2">Predmet</Table.HeaderCell>
                                <Table.HeaderCell >Tip ispita</Table.HeaderCell>
                                <Table.HeaderCell>Datum i vrijeme ispita</Table.HeaderCell>
                                <Table.HeaderCell>Napomena</Table.HeaderCell>
                                {/* <Table.HeaderCell> */}
                                {/*    <Header as="h4" image> */}
                                {/*        <Header.Content> */}
                                {/*            Datum ponovnog otvaranja ispita */}
                                {/*            <Header.Subheader>(odluka)</Header.Subheader> */}
                                {/*        </Header.Content> */}
                                {/*    </Header> */}
                                {/* </Table.HeaderCell> */}
                                <Table.HeaderCell>Datum ponovnog otvaranja ispita (odluka)</Table.HeaderCell>
                                <Table.HeaderCell width="2" verticalAlign="middle" textAlign='center'>
                                    <ExcelFile filename="Spisak nefinaliziranih ispita" element={<Popup
                                        trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                            <Button.Content visible>
                                                Excel
                                            </Button.Content>
                                        </Button>}
                                        content="Preuzmi spisak u Excel-u"
                                        hideOnScroll
                                        position="top center"
                                    />}>
                                        <ExcelSheet dataSet={multiDataSet} name="Studenti" />
                                    </ExcelFile>
                                    {/*<ExportReactCSV color="green" csvData={this.state.data} headers={headersForExport} fileName="Spisak nefinaliziranih ispita" />*/}
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                            { this.state.loader?
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell verticalAlign="middle" textAlign='center'>
                                          <Loader active inline="centered" />
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                                :  <Table.Body>  {this.getDataToRender().filter(e => !e.finalized).map((el, index) =>
                            (<Table.Row >
                                <Table.Cell width="1" verticalAlign="middle">
                                    {index +1}.
                                </Table.Cell>
                                <Popup
                                    content={el.semesterNameKey === 'winter semester' ? 'Implementacija predmeta u zimskom semestru' : 'Implementacija predmeta u ljetnom semestru'}
                                    hideOnScroll
                                    position="left center"
                                    trigger={<Table.Cell verticalAlign="middle" colSpan="2">
                                        <Grid columns={1} centered className="stackable">
                                            <Grid.Row verticalAlign="middle">
                                                <Grid.Column width="10">
                                                    <span >  { el.semesterNameKey === 'winter semester' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />}{el.courseImplementationName}</span>
                                                </Grid.Column>
                                                <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                    <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </Table.Cell>}
                                />
                                <Table.Cell verticalAlign="middle">
                                    {el.gradedActivityName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {moment(el.gradedActivityDate).format('D. M. YYYY. - HH:mm')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.comment}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.finalizationCancelDate ? moment(el.finalizationCancelDate).format('D. M. YYYY.') + '\n' : ''}
                                    {el.documentNumber ? ' ( Odluka: ' + el.documentNumber + ')' : ''}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" textAlign="center" width="2">
                                    <Popup
                                        content="Detalji"
                                        position="top center"
                                        trigger={<Link to={{
                                            pathname: '/ispitni-rokovi/ispiti/detalji',
                                        }}
                                        >
                                            <Button
                                                basic="true"
                                                circular
                                                icon="align justify"
                                                size="small"
                                                color="blue"
                                                onClick={() => {
                                                    localStorage.setItem('gradedActivityId', el.gradedActivityId);
                                                    localStorage.setItem('courseImplementationName', el.courseImplementationName ? el.courseImplementationName : '');
                                                    localStorage.setItem('gradedActivityName', el.gradedActivityName ? el.gradedActivityName : '');
                                                    localStorage.setItem('gradedActivityDate', el.gradedActivityDate ? el.gradedActivityDate : '');
                                                    localStorage.setItem('courseImplementationId', el.courseImplementationId);
                                                    localStorage.setItem('classroom', el.classroom ? el.classroom : '');
                                                    localStorage.setItem('comment', el.comment ? el.comment : '');
                                                    localStorage.setItem('gradingMethodId', el.gradingMethodId ? el.gradingMethodId : '');
                                                    localStorage.setItem('gradedActivityTypeId', el.gradedActivityTypeId);
                                                    localStorage.setItem('gradedActivityRegistrationDateStart', el.gradedActivityRegistrationDateStart ? el.gradedActivityRegistrationDateStart : '');
                                                    localStorage.setItem('gradedActivityRegistrationDateEnd', el.gradedActivityRegistrationDateEnd ? el.gradedActivityRegistrationDateEnd : '');
                                                    localStorage.setItem('optLock', el.optLock);
                                                    localStorage.setItem('gradedActivityRegistrationClosing', el.gradedActivityRegistrationClosing ? el.gradedActivityRegistrationClosing : '');
                                                    localStorage.removeItem('finalized');
                                                    localStorage.setItem('courseComment', el.courseComment);
                                                }}
                                            />
                                        </Link>}/>
                                    {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && <Popup
                                        content="Brisanje"
                                        position="top center"
                                        trigger={
                                            <Button
                                                basic="true"
                                                circular
                                                icon="trash alternate"
                                                size="small"
                                                color="red"
                                                onClick={() => this.removeExam(el.gradedActivityId)}
                                            />}
                                    />}
                                </Table.Cell>
                            </Table.Row>))
                        }
                        </Table.Body>}
                    </Table> : <div><br />Nema nefinaliziranih ispita.</div>}</Tab.Pane>)
            },
            {
                menuItem: 'Finalizirani ispiti',
                render: () => (<Tab.Pane as={Responsive}>
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field
                                clearable
                                control={Select}
                                label="Odsjek / smjer"
                                placeholder="Odaberite odsjek / smjer"
                                name="SPBasic"
                                options={this.state.SPBasics}
                                value={this.state.SPBasic}
                                onChange={this.handleInputChange}

                            />
                            <Form.Field
                                control={Input}
                                label="Predmet"
                                placeholder="Unesite predmet"
                                name="name"
                                value={this.state.name}
                                onChange={this.handleInputChange}

                            />
                            <Form.Field>
                                <label>Datum ispita</label>
                                <DateTimePicker
                                    time={false}
                                    format="D. M. YYYY."
                                    onChange={this.handleDateChange.bind(null, 'date')}
                                    value={this.state.date}
                                    placeholder="Unesite datum"
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                    {this.getDataToRender().filter(e => e.finalized).length ? <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width="1">R.br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2" >Predmet</Table.HeaderCell>
                                <Table.HeaderCell >Tip ispita</Table.HeaderCell>
                                <Table.HeaderCell>Datum i vrijeme ispita</Table.HeaderCell>
                                <Table.HeaderCell>Napomena</Table.HeaderCell>
                                {/* <Table.HeaderCell> */}
                                {/*    <Header as="h4" image> */}
                                {/*        <Header.Content> */}
                                {/*            Datum ponovnog otvaranja ispita */}
                                {/*            <Header.Subheader>(odluka)</Header.Subheader> */}
                                {/*        </Header.Content> */}
                                {/*    </Header> */}
                                {/* </Table.HeaderCell> */}
                                <Table.HeaderCell>Datum ponovnog otvaranja ispita (odluka)</Table.HeaderCell>
                                <Table.HeaderCell verticalAlign="middle" textAlign='center'>
                                    <ExcelFile filename="Spisak finaliziranih ispita" element={<Popup
                                        trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                            <Button.Content visible>
                                                Excel
                                            </Button.Content>
                                        </Button>}
                                        content="Preuzmi spisak u Excel-u"
                                        hideOnScroll
                                        position="top center"
                                    />}>
                                        <ExcelSheet dataSet={multiDataSetFinalized} name="Studenti" />
                                    </ExcelFile>
                                    {/*<ExportReactCSV color="green" csvData={this.state.data} headers={headersForExport} fileName="Spisak finaliziranih ispita" />*/}
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>  {this.getDataToRender().filter(e => e.finalized).map((el, index) =>
                            (<Table.Row positive={el.archived} negative={!el.archived}>
                                <Table.Cell width="1" verticalAlign="middle">
                                    {index +1}.
                                </Table.Cell>
                                <Popup
                                    content={el.semesterNameKey === 'winter semester' ? 'Implementacija predmeta u zimskom semestru' : 'Implementacija predmeta u ljetnom semestru'}
                                    hideOnScroll
                                    position="left center"
                                    trigger={<Table.Cell verticalAlign="middle" colSpan="2">
                                        <Grid columns={1} centered className="stackable">
                                            <Grid.Row verticalAlign="middle">
                                                <Grid.Column width="10">
                                                    <span >  { el.semesterNameKey === 'winter semester' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />}{el.courseImplementationName}</span>
                                                </Grid.Column>
                                                <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                    <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </Table.Cell>}
                                />
                                <Table.Cell verticalAlign="middle">
                                    {el.gradedActivityName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {moment(el.gradedActivityDate).format('D. M. YYYY. - HH:mm')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.comment}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.finalizationCancelDate ? moment(el.finalizationCancelDate).format('D. M. YYYY.') + '\n' : ''}
                                    {el.documentNumber ? ' ( Odluka: ' + el.documentNumber + ')' : ''}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" textAlign="center">
                                    {this.state.inputDocNum === false && <Link to={{
                                        pathname: '/ispitni-rokovi/ispiti/detalji',
                                    }}
                                    >
                                        <Popup
                                            content="Detalji"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="align justify"
                                                    size="small"
                                                    color="blue"
                                                    onClick={() => {
                                                        localStorage.setItem('gradedActivityId', el.gradedActivityId);
                                                        localStorage.setItem('courseImplementationName', el.courseImplementationName ? el.courseImplementationName : '');
                                                        localStorage.setItem('gradedActivityName', el.gradedActivityName ? el.gradedActivityName : '');
                                                        localStorage.setItem('gradedActivityDate', el.gradedActivityDate ? el.gradedActivityDate : '');
                                                        localStorage.setItem('courseImplementationId', el.courseImplementationId);
                                                        localStorage.setItem('classroom', el.classroom ? el.classroom : '');
                                                        localStorage.setItem('comment', el.comment ? el.comment : '');
                                                        localStorage.setItem('gradingMethodId', el.gradingMethodId ? el.gradingMethodId : '');
                                                        localStorage.setItem('gradedActivityTypeId', el.gradedActivityTypeId);
                                                        localStorage.setItem('gradedActivityRegistrationDateStart', el.gradedActivityRegistrationDateStart ? el.gradedActivityRegistrationDateStart : '');
                                                        localStorage.setItem('gradedActivityRegistrationDateEnd', el.gradedActivityRegistrationDateEnd ? el.gradedActivityRegistrationDateEnd : '');
                                                        localStorage.setItem('optLock', el.optLock);
                                                        localStorage.setItem('gradedActivityRegistrationClosing', el.gradedActivityRegistrationClosing ? el.gradedActivityRegistrationClosing : '');
                                                        localStorage.setItem('grades', true);
                                                        localStorage.setItem('finalized', true);
                                                        localStorage.setItem('courseComment', el.courseComment);
                                                    }}
                                                />}
                                        />
                                    </Link>}
                                    {this.state.inputDocNum === false && <Link to={{
                                        pathname: '/ispitni-rokovi/ispiti/prijave-za-ispite',
                                        state: { gradedActivityId: el.gradedActivityId, gradedActivityName: el.gradedActivityName, courseImplementationName: el.courseImplementationName }
                                    }}
                                    >
                                        {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && <Popup
                                            content="Prijave"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="copy outline"
                                                    size="medium"
                                                    color="teal"
                                                    onClick={() => {
                                                        localStorage.setItem('gradedActivityId', el.gradedActivityId);
                                                        localStorage.setItem('courseImplementationId', el.courseImplementationId);
                                                        localStorage.setItem('courseImplementationName', el.courseImplementationName ? el.courseImplementationName : '');
                                                        localStorage.setItem('gradedActivityName', el.gradedActivityName ? el.gradedActivityName : '');
                                                        localStorage.setItem('gradedActivityDate', el.gradedActivityDate ? el.gradedActivityDate : '');
                                                        localStorage.setItem('courseComment', el.courseComment);
                                                    }}
                                                />}
                                        />}
                                    </Link>}

                                    {this.state.inputDocNum === index ?
                                        <div>
                                            {this.state.load ? <Form noValidate>
                                                <Form.Field
                                                    required
                                                    control={Input}
                                                    label="Unesite broj odluke"
                                                    value={this.state.documentNumber}
                                                    onChange={(e) => this.setState({ documentNumber: e.target.value })}
                                                    name="documentNumber"
                                                    placeholder="Unesite broj odluke"
                                                    error={this.state.docNumErr}
                                                />

                                                <Button
                                                    size="small"
                                                    color="blue"
                                                    icon="check"
                                                    circular
                                                    onClick={() => this.unfinalizedExam(el.gradedActivityId, el.optLock)}
                                                />
                                                <Button
                                                    size="small"
                                                    basic="true"
                                                    color="blue"
                                                    circular
                                                    icon="close"
                                                    onClick={() => { this.setState({ inputDocNum: false }); }}
                                                />
                                            </Form> : <Loader active inline="centered" />}
                                        </div>
                                        : (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') &&<Popup
                                            content="Otvaranje ispita"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="unlock"
                                                    size="medium"
                                                    color="green"
                                                    onClick={() => this.setState({ inputDocNum: index })}
                                                />}
                                        />
                                    }

                                    {(this.state.inputDocNum === false && !el.archived && (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja')) ? <Popup
                                        trigger={<Icon
                                            name="checkmark"
                                            color="green"
                                            style={{ cursor: 'pointer', float: 'right' }}
                                            onClick={() => { el.archived !== true && this.archive(el.gradedActivityId, el.optLock); }}
                                        />}
                                        content="Arhiviranje ispita nakon završenog printanja prijava."
                                    /> : <Icon />
                                    }
                                </Table.Cell>
                            </Table.Row>))
                        }
                        </Table.Body>
                    </Table> : <div><br />Nema finaliziranih ispita.</div>}</Tab.Pane>)
            }
        ];

        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header as="h1">Spisak ispita</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            {localStorage.getItem('name') ? localStorage.getItem('name') : this.props.location.state.name}
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        // onClick={() => { localStorage.setItem('returned', true); this.setState({back: true}) }}
                                        onClick={() => { window.history.go(-1); }}
                                    />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader>
                                Ispitni rok
                            </Header.Subheader>

                        </Header>
                    </Segment>

                    <Segment><Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} /></Segment>
                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/Exams.js